import { LazyParamsFilters } from '@/app/models/distribution'
import { LUX_INPUT_TYPE } from '@lux/wardrobe-lib'
import { FilterMatchMode } from 'primereact/api'

export const columns = (isMobile: boolean) => [
    {
        field: 'store_name',
        header: 'modals.new.activity.section.distribution.table.store.name',
        isMain: !isMobile,
        sortable: true,
        width: isMobile ? 125 : 165,
        filterType: LUX_INPUT_TYPE.text,
        wrapOverflow: true,
    },
    {
        field: 'store_id',
        header: 'modals.new.activity.section.distribution.table.store.id',
        sortable: true,
        isMain: !isMobile,
        width: 100,
        filterType: LUX_INPUT_TYPE.text,
    },
    {
        field: 'banner_desc',
        header: 'modals.new.activity.section.distribution.table.banner',
        sortable: true,
        isMain: !isMobile,
        width: 150,
        filterType: LUX_INPUT_TYPE.multiselect,
    },
    {
        field: 'country',
        //isMain: true,
        sortable: true,
        width: 200,
        header: 'modals.new.activity.section.distribution.table.country',
        filterType: LUX_INPUT_TYPE.multiselect,
    },
    {
        field: 'macroregion',
        //isMain: true,
        sortable: true,
        width: 150,
        header: 'modals.new.activity.section.distribution.table.macroregion',
        filterType: LUX_INPUT_TYPE.multiselect,
    },
    {
        field: 'region',
        width: 200,
        sortable: true,
        header: 'modals.new.activity.section.distribution.table.region',
        filterType: LUX_INPUT_TYPE.multiselect,
    },
    {
        field: 'zone_desc',
        width: 150,
        sortable: true,
        header: 'modals.new.activity.section.distribution.table.zone_desc',
        filterType: LUX_INPUT_TYPE.multiselect,
    },
    {
        field: 'store_location',
        width: 250,
        // sortable: true,
        header: 'modals.new.activity.section.distribution.table.store_location',
        filterType: LUX_INPUT_TYPE.multiselect,
    },
    {
        field: 'city',
        width: 150,
        // sortable: true,
        header: 'modals.new.activity.section.distribution.table.city',
        filterType: LUX_INPUT_TYPE.multiselect,
    },
    {
        field: 'segment',
        width: 150,
        // sortable: true,
        header: 'modals.new.activity.section.distribution.table.segment',
        filterType: LUX_INPUT_TYPE.multiselect,
    },
    {
        field: 'store_host_name',
        width: 250,
        // sortable: true,
        header: 'modals.new.activity.section.distribution.table.store_host_name',
        filterType: LUX_INPUT_TYPE.multiselect,
    },
    {
        field: 'business_model',
        width: 150,
        sortable: true,
        header: 'modals.new.activity.section.distribution.table.business_model',
        filterType: LUX_INPUT_TYPE.multiselect,
    },
]

export const mappingSmartFilter = {
    banner_desc: 'bannerDesc',
    macroregion: 'macroregion',
    country: 'country',
    region: 'region',
    zone_desc: 'zoneDesc',
    store_location: 'storeLocation',
    city: 'city',
    segment: 'segment',
    store_host_name: 'storeHostName',
    business_model: 'businessModel',
}
